import React from "react";
import {SearchForm} from "./searchForm"
import ConfigList from "./configList"
const Config = ():JSX.Element => {
    return (
        <>
            <SearchForm/>
            <ConfigList/>
        </>
    )
}
export default Config